import React from "react";
import { animated, useSpring } from "react-spring";
import Location from "./Location";
import { useTranslation } from "react-i18next";
import { useTransition, config as springConfig } from "react-spring";

import Square from "/assets/images/FactsAndFigures/square.svg";
import Circle from "/assets/images/FactsAndFigures/circle.svg";
import Triangle from "/assets/images/FactsAndFigures/triangle.svg";
import { useEbbnenContext } from "@solidwhite/ebbnen";

const FactAndFiguresUI = ({ style }) => {
  const { t } = useTranslation();

  const locations = [
    {
      name: "manufacturing",
      translationKey: "L2_FACTS_AND_FIGURES_MANUFACTURING",
      image: Square,
    },

    {
      name: "sales_service",
      translationKey: "L2_FACTS_AND_FIGURES_SALES_AND_SERVICE",
      image: Triangle,
    },
  ];

  return (
    <animated.div
      style={{
        ...style,
        position: "absolute",
        bottom: "0",
        left: "0",
        width: "100%",
        zIndex: "1",
        height: "15vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignContent: "center",
        paddingLeft: "25vw",
        fontSize: "0.75vw",
        pointerEvents: "none",
      }}
    >
      <p
        style={{
          color: "rgba(255, 255, 255, 0.4)",
          marginTop: 0,
          marginBottom: "20px",
        }}
      >
        {t("L1_FACTS_AND_FIGURES_SELECT_LOCATION")}
      </p>
      <div
        style={{
          display: "flex",
        }}
      >
        {locations.map((location) => (
          <Location key={location.name} location={location} />
        ))}
      </div>
    </animated.div>
  );
};

export const FactAndFiguresUITransition = ({ visible = false }) => {
  const transition = useTransition(visible, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    config: { duration: 200 },
    delay: 500,
  });

  return transition((style, item) => item && <FactAndFiguresUI style={style} />);
};

export default FactAndFiguresUI;
